<div class="container-block-map">
    <aside class="block-schedule">
        <router-outlet></router-outlet>
    </aside>

    <div class="block-schedule-map" [ngClass]="isFullMap ? 'full-map' : ''">
        <div [ngStyle]="{ display: isFullMap ? 'none' : 'block' }" (click)="toggleMapSize()"></div>
        <div class="flex-center">
            <button class="increase-map" (click)="toggleMapSize()">
                <span *ngIf="!isFullMap">{{ 'SCHEDULE_MAP_INCREASE_TITLE' | translate }}</span>
                <span *ngIf="isFullMap">{{ 'SCHEDULE_MAP_DECREASE_TITLE' | translate }}</span>
            </button>
        </div>

        <rwidget-map
            [latitude]="mapCenter.latitude"
            [longitude]="mapCenter.longitude"
            [fullMap]="isFullMap"
            [allowPointClick]="env.MAP.HIDE_JOURNEY_PLANNER ? false : true"
            (pointClicked)="onPointClicked($event)"
            (mapReady)="onMapReady()">
            <rwidget-map-popup>
                <mat-nav-list class="remove-padding">
                    <mat-list-item (click)="onDepartureClicked()">
                        <div mat-line>{{ 'SCHEDULE_SET_AS_DEPARTURE' | translate }}</div>
                        <mat-icon>chevron_right</mat-icon>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item (click)="onDestinationClicked()">
                        <div mat-line>{{ 'SCHEDULE_SET_AS_DESTINATION' | translate }}</div>
                        <mat-icon>chevron_right</mat-icon>
                    </mat-list-item>
                </mat-nav-list>
            </rwidget-map-popup>

            <rwidget-map-layer-group [label]="'SCHEDULE_BUSES_LAYER' | translate">
                <rwidget-map-marker
                    *ngFor="let bus of busLocations$ | async"
                    [latitude]="bus.latitude"
                    [longitude]="bus.longitude">
                    <rwidget-map-icon [anchor]="[17, 17]" [size]="[34, 34]">
                        <rwidget-map-bus-icon
                            [bus]="bus"
                            [selectedBus]="selectedBus$ | async"
                            (busClicked)="onBusClicked($event)">
                        </rwidget-map-bus-icon>
                    </rwidget-map-icon>
                </rwidget-map-marker>

                <rwidget-map-polyline [weight]="5" [color]="polylineColor">
                    <rwidget-map-polyline-point
                        *ngFor="let trip of busRoute$ | async"
                        [latitude]="trip.point_latitude"
                        [longitude]="trip.point_longitude">
                    </rwidget-map-polyline-point>
                </rwidget-map-polyline>
            </rwidget-map-layer-group>

            <rwidget-map-marker
                [latitude]="(selectedOrigin$ | async)?.lat"
                [longitude]="(selectedOrigin$ | async)?.lon"
                [isSingle]="true">
                <rwidget-map-icon [url]="iconOrigin" [size]="[18, 24]" [anchor]="[9, 24]"></rwidget-map-icon>
            </rwidget-map-marker>

            <rwidget-map-marker
                [latitude]="(selectedDestination$ | async)?.lat"
                [longitude]="(selectedDestination$ | async)?.lon"
                [isSingle]="true">
                <rwidget-map-icon [url]="iconDestination" [size]="[24, 24]"></rwidget-map-icon>
            </rwidget-map-marker>

            <ng-container *ngIf="resRobotTrips && stopIds.length === 0">
                <rwidget-map-polyline [color]="polylineColor">
                    <rwidget-map-polyline-point
                        *ngFor="let trip of resRobotTrips"
                        [latitude]="trip[0]"
                        [longitude]="trip[1]">
                    </rwidget-map-polyline-point>
                </rwidget-map-polyline>
            </ng-container>

            <rwidget-map-layer-group
                *ngIf="stopIds.length === 0"
                [label]="'SCHEDULE_STOPS_LAYER' | translate"
                [showOnMap]="true">
                <rwidget-map-marker-group [markers]="stops" (markerClicked)="onStopClicked($event)">
                    <rwidget-map-icon
                        [url]="iconStop"
                        [retinaUrl]="iconStopRetina"
                        [anchor]="[15, 44]"></rwidget-map-icon>
                    <rwidget-map-popup>
                        <div class="popup-title text-base">
                            <p>{{ clickedStop?.stop_name }}</p>
                        </div>
                        <mat-nav-list class="remove-padding" *ngIf="showBookARide">
                            <mat-list-item
                                (click)="
                                    onDepartureClicked({
                                        name: clickedStop.stop_name,
                                        lat: clickedStop.stop_lat,
                                        lon: clickedStop.stop_lon
                                    })
                                ">
                                <div mat-line>{{ 'SCHEDULE_SET_AS_DEPARTURE' | translate }}</div>
                                <mat-icon>chevron_right</mat-icon>
                            </mat-list-item>
                            <mat-divider></mat-divider>
                            <mat-list-item
                                (click)="
                                    onDestinationClicked({
                                        name: clickedStop.stop_name,
                                        lat: clickedStop.stop_lat,
                                        lon: clickedStop.stop_lon
                                    })
                                ">
                                <div mat-line>{{ 'SCHEDULE_SET_AS_DESTINATION' | translate }}</div>
                                <mat-icon>chevron_right</mat-icon>
                            </mat-list-item>
                        </mat-nav-list>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>
            </rwidget-map-layer-group>

            <ng-container *ngIf="stopIds.length > 0">
                <rwidget-map-layer-group [fit]="true">
                    <rwidget-map-marker
                        *ngFor="let id of stopIds"
                        [latitude]="(stops$ | async)[id].stop_lat"
                        [longitude]="(stops$ | async)[id].stop_lon">
                        <rwidget-map-icon
                            *ngIf="id !== (selectedId$ | async)"
                            [url]="iconSelectedStop"
                            [retinaUrl]="iconSelectedStopRetina"
                            [anchor]="[15, 44]"></rwidget-map-icon>
                        <rwidget-map-icon
                            *ngIf="id === (selectedId$ | async)"
                            [url]="iconActiveStop"
                            [retinaUrl]="iconActiveStopRetina"
                            [anchor]="[25, 54]"
                            [size]="[50, 54]"></rwidget-map-icon>
                        <rwidget-map-popup>
                            <mat-list class="remove-padding">
                                <mat-list-item>{{ (stops$ | async)[id].stop_name }}</mat-list-item>
                            </mat-list>
                        </rwidget-map-popup>
                    </rwidget-map-marker>
                </rwidget-map-layer-group>

                <rwidget-map-polyline
                    *ngIf="routePolyline$ | async"
                    [encodedPath]="(routePolyline$ | async).polyline"
                    [color]="polylineColor">
                </rwidget-map-polyline>
            </ng-container>

            <rwidget-map-locator></rwidget-map-locator>
        </rwidget-map>
    </div>
</div>
